import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { AppClient } from "../mutation/useAppClientMutation";


type TokensResponse = ResponseType<AppClient[]>;

function useAllTokensQuery() {
  return useQuery<
    AxiosResponseAndError<TokensResponse>["response"],
    AxiosResponseAndError<TokensResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.allToken],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.appClient),
    enabled: true,
    refetchOnMount : false,
  });
}

export default useAllTokensQuery;
